import { useQuery } from '@tanstack/react-query';
import { getCitySearchResults } from './api/getCitySearchResults';
import { isValidCitySearchQuery, normalizeCitySearchQuery } from './utils';
import { CityResponseData } from './api/models';

export const useCitySearch = (query: string) => {
    // Normalize before React Query, so equivalent input shares cache/enabled state.
    const normalizedQuery = normalizeCitySearchQuery(query);

    return useQuery<Array<CityResponseData>>({
        queryKey: ['citySearch', normalizedQuery],
        queryFn: async () => getCitySearchResults(normalizedQuery),
        refetchOnMount: false,
        enabled: isValidCitySearchQuery(normalizedQuery),
        refetchOnWindowFocus: false,
        retry: false,
    });
};
